import { environmentHttpClient as httpClient } from "client/Api/httpClient";

enum ZaaksysteemCaseStatus {
	Open = 0,
	Stalled = 1
}

enum ZaaksysteemResourceKind {
	MyOpenCases = 0,
	MySuspendedCases = 1
}

type Interests = {
	items?: boolean;
	count?: boolean;
};

enum ResultStatus {
	GeneralFailure = 0,
	Success = 1,
	NoAccess = 2
}

type CaseListItemModel = {
	status: ZaaksysteemCaseStatus;
	subject: string;
	caseType: string;
	requester: string;
	caseNumber: number;
	navigationUrl: string;
};

type LiveInformationRequestModel = {
	connectionId: number;
	resourceKind: ZaaksysteemResourceKind;
	interestedIn: Interests;
};

type ItemsLiveInformationResponseModel = {
	items: ReadonlyArray<CaseListItemModel>;
	hasMore: boolean;
};

type CountLiveInformationResponseModel = {
	count: number;
};

type LiveInformationResponseModel = {
	connectionId: number;
	resourceKind: ZaaksysteemResourceKind;
} & ({
	status: ResultStatus.Success;
	itemsResponse?: ItemsLiveInformationResponseModel;
	countResponse?: CountLiveInformationResponseModel;
} | {
	status: Exclude<ResultStatus, ResultStatus.Success>;
});

function getLiveInformation(requestModels: ReadonlyArray<LiveInformationRequestModel>): Promise<ReadonlyArray<LiveInformationResponseModel>> {
	return httpClient.post<ReadonlyArray<LiveInformationResponseModel>>("Workspace/LiveInformation/Zaaksysteem", requestModels);
}

function getMyCases(
	caseStatus: ZaaksysteemCaseStatus,
	connectionId: number,
	page: number,
	searchTerm: string,
	signal?: AbortSignal
): Promise<ItemsLiveInformationResponseModel> {
	return httpClient.get<ItemsLiveInformationResponseModel>(
		"Workspace/LiveInformation/Zaaksysteem/MyCases",
		{
			caseStatus,
			connectionId,
			page,
			searchTerm
		},
		{ signal }
	);
}

export {
	ZaaksysteemCaseStatus,
	ZaaksysteemResourceKind,
	type CaseListItemModel as ZaaksysteemCaseListItemModel,
	ResultStatus as ZaaksysteemResultStatus,
	type LiveInformationRequestModel as ZaaksysteemLiveInformationRequestModel,
	type LiveInformationResponseModel as ZaaksysteemLiveInformationResponseModel,
	type Interests as ZaaksysteemInterests,
	type ItemsLiveInformationResponseModel,

	getLiveInformation,
	getMyCases
};